var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Neuer Benutzer"}},[_c('user-form',{attrs:{"user":_vm.user,"submit-label":"Neuen Benutzer anlegen","form-submitted":_vm.saveUser,"mode":"new"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }